import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal";
import React, {useEffect, useState} from "react";
import Input from "../../../components/form/Input";
import TextArea from "../../../components/form/TextArea";
import {ImageUploadCard} from "../../../components/ImageUploadCard";
import {useDispatch, useSelector} from "react-redux";
import {setPagesAddingOrEditing, tryAddOrUpdateDynamicUiPage} from "../../../redux/slices/dynamicUiSlice";
import useInput from "../../../hooks/useInput";
import {toKebabCase} from "../../../helpers/helperFunctions";
import DynamicPageGroupSelect from "./DynamicPageGroupSelect";

const DynamicUIPageAddModal = () => {

  const dispatch = useDispatch();
  const [metaImage, setMetaImage] = useState("");
  const [pageGroup, setPageGroup] = useState("");
  const {adding, editing} = useSelector((state) => state.dynamicUi.pages.modify);
  const { loading: addingPages} = useSelector((state) => state.dynamicElements.editing);


  const pageName = useInput("");
  const pageSeoTitle = useInput("");
  const [pageSeoDescription, setPageSeoDescription] = useState("");
  const pageSeoSlug = useInput("");

  useEffect(() => {
    if (!adding && !editing) {
      pageName.setValue("");
      pageSeoTitle.setValue("");
      setPageSeoDescription("");
      pageSeoSlug.setValue("");
      setMetaImage("");
      setPageGroup("");
    }

    if(editing){
      pageName.setValue(editing.title ?? "");
      pageSeoTitle.setValue(editing.seo_details?.title??"");
      setPageSeoDescription(editing.seo_details?.description??"");
      pageSeoSlug.setValue(editing.seo_details?.slug ?? "");
      setMetaImage(editing.seo_details?.image ?? "");
      setPageGroup(editing.group ?? "");
    }

  }, [adding, editing]);


  const onSubmit = () => {
    const payload = {
      pageData: {
        title: pageName.value.trim(),
        group: pageGroup,
        seo_details: {
          image: metaImage,
          description: pageSeoDescription.trim(),
          title: pageSeoTitle.value.trim(),
          slug: toKebabCase(pageSeoSlug.value.trim())
        }
      },
      editing

    };
    dispatch(tryAddOrUpdateDynamicUiPage(payload));
  };

  const isAllFieldsValid = () => pageName.value.trim() &&
    pageGroup &&
    pageSeoTitle.value.trim() && pageSeoDescription.trim() &&
    metaImage && (!pageSeoSlug.value.trim() ||
      pageSeoSlug.value.trim().length > 2);
  // const isAllFieldsValid = () => false;

  const generateSlug = () => {
    if (pageSeoTitle.value.length > 2)
      pageSeoSlug.setValue(toKebabCase(pageSeoTitle.value));
  };

  const isNotMainPage = !!editing?.deletable || !editing

  return (<CustomModal
    title={adding ? "Add a new Page" : "Edit Page"}
    children={
      <div>
        <div className="flex space-x-4">
          <Input
            label="Page Name"
            value={pageName.value}
            onChange={pageName.onChange}
            disabled={addingPages}
          />
          <DynamicPageGroupSelect
            label="Group"
            value={pageGroup}
            setValue={setPageGroup}
            disabled={addingPages}
            className='w-full'
          />
        </div>

        <div className="relative">
          <div className="absolute -top-2 left-5 bg-white px-1 text-xs font-bold">Seo Details</div>
          <div className="flex flex-col sm:flex-row sm:space-x-5 border sm:p-5 p-3">
            <div className="flex-1">
              <ImageUploadCard
                permanentRemove={false}
                initialImage={metaImage ?? ""}
                title="Meta Image"
                onImageUploaded={setMetaImage}
                onImageRemoved={setMetaImage}
                disabled={addingPages}
              />
            </div>
            <div className="flex-1">
              <div className="flex items-center space-x-2">
                <Input
                  label="Title"
                  value={pageSeoTitle.value}
                  onChange={pageSeoTitle.onChange}
                  className="flex-1"
                  disabled={addingPages}
                />
                {isNotMainPage && <CustomButton className="whitespace-nowrap mt-1.5" onClick={generateSlug}
                              disabled={pageSeoTitle.value.trim().length < 3 || addingPages}>
                  Generate Slug
                </CustomButton>}
              </div>


              <TextArea
                label={"Description"}
                value={pageSeoDescription}
                onChange={(v) => setPageSeoDescription(v)}
                disabled={addingPages}
              />

              {(isNotMainPage) && <Input
                label="Slug"
                value={pageSeoSlug.value}
                onChange={pageSeoSlug.onChange}
                disabled={addingPages}
                isRequired={false}
              />}
            </div>

          </div>
        </div>
      </div>
    }
    showModal={adding || editing}
    setShowModal={() => dispatch(setPagesAddingOrEditing({clear: true}))}
    loading={addingPages}
    button={<CustomButton children={"Submit"} onClick={onSubmit} disabled={!isAllFieldsValid() || addingPages}/>}
  />);
};

export default DynamicUIPageAddModal;
